<script>
    import { Router, links, Link, Route, navigate } from "svelte-routing";
    import { onMount, tick } from 'svelte';
    import { activeMenu } from "../../stores";
    import api_handleApiCalls from "../../utils/apiCallHandler.js";
    export let _id;

    let assignmentObj = {
        topic: "",
        submissionDate: "",
        submissionTime: "",
        notes: "",
    }
    let assignmentStatus;
    
    let remarkAssignmentObj = {
        remarkFile:[]
    }


    let assignmentStatus1 ;
    let assignmentRemark;
    let errorObj = {}
    let clearError = (key) => {
        delete errorObj[key];
        errorObj = { ...errorObj }; // reset state
    }

    let fileObj;
    let elem_uploadAttachmentInput;
    let elem_submitAssignmentFile;

    let submitAssignmentObj = {
        notes: ''
    }
    async function api_getListOfFiles(data) {

        let action = "storage.getUrlForUpload";
        var response = await api_handleApiCalls(action, data);
        return response;

    }

    async function api_updateFileName(data) {

        let action = "storage.updateFileName";
        var response = await api_handleApiCalls(action, data);
        return response;

    }

    async function api_getUrlForUpload(data) {

        let action = "storage.getUrlForUpload";
        var response = await api_handleApiCalls(action, data);
        return response;

    }

    async function api_updateSubmittedFileUrl(data) {

        let action = "assignmentprogress.updateSubmittedFileUrl";
        var response = await api_handleApiCalls(action, data);
        return response;

    }

    function containsSpecialChars(str) {
        const specialChars = /[`!@#$%^&*()+\-=\[\]{};':"\\|,<>\/?~]/;
        return specialChars.test(str);
    }

    let filepondOptions = {
        allowDownloadByUrl: true,
        acceptedFileTypes: ["image/*", "application/*", "text/*"],

        server: {
           
            process: async (fieldName, file, metadata, load, error, progress, abort, transfer, options) => {
                // fieldName is the name of the input field
                // file is the actual file object to send
                const formData = new FormData();
                formData.append(fieldName, file, file.name);

                let originalFileName = file.name;
                if (containsSpecialChars(originalFileName)) {
                    PNotify.error({
                        title: 'Error',
                        text: 'Please change the file name and upload again.',
                        delay: 3000
                    })
                    abort()
                    return 
                }
                let _fileName = file.name.split(".");

                var fileExtension = _fileName[_fileName.length - 1];
                var fileSize = file.size
                //  var formData = new FormData();
                // formData.append('file', file, "newFileName"+_fileName);

                var res = await api_getUrlForUpload({
                    name: originalFileName,
                    type: file.type,
                    uploadType: "ASSIGNMENTPROGRESS",
                    fileId: _id
                });
                console.log("res : ", res)
                if (res.status) {
                    _$.ajax({
                        xhr: function () {
                            var xhr = new window.XMLHttpRequest();
                            xhr.upload.addEventListener("progress", function (e) {
                                // var percentComplete = (evt.loaded / evt.total) * 100;
                                progress(e.lengthComputable, e.loaded, e.total);
                                // console.log("percentComplete : ", percentComplete)
                            }, false);
                            return xhr;
                        },
                        url: res.data.url,
                        type: "PUT",
                        data: file,
                        dataType: "text",
                        cache: false,
                        contentType: file.type,
                        processData: false
                    })
                        .done(async function (resss) {
                            await api_updateSubmittedFileUrl({
                                fileId: _id,
                                originalFileName: originalFileName,
                                fileExtension: fileExtension,
                                fileSize: fileSize,
                                url: res.data.url,
                            })
                            console.log("asdfasd : ", resss)
                            console.info('YEAH', res.data.url.split('?')[0].substr(6));
                            load("Done");
                        })
                        .fail(function (err) {
                            error('oh no');
                            console.error('damn...', err);
                        })
                } else {
                    // todo show erro toast
                }
                return {
                    abort: () => {
                        // This function is entered if the user has tapped the cancel button
                        // request.abort();
                        
                        // Let FilePond know the request has been cancelled
                        abort();
                    }
                };
            }
        }
    }

    onMount(async () => {
        activeMenu.set('studentAssignment');
        _$.fn.filepond.setOptions({
            server: {
                url: "{{ url('upload')}}",
                process: {
                    headers: {
                        'X-CSRF-TOKEN': "csrf"
                    },
                }
            }
        })
        _$.fn.filepond.registerPlugin(FilePondPluginFileValidateType);
        _$.fn.filepond.registerPlugin(FilePondPluginGetFile);
        _$(elem_submitAssignmentFile).filepond(filepondOptions);
        var _submitedFileObj;
        if (_id) {
            let result = await api_getAssignmentProgressById();
            if (result.status) {
                _submitedFileObj = result.data[0].submittedFile ? result.data[0].submittedFile : [];
                assignmentObj = {
                    topic: result.data[0].assignmentDetails.topic,
                    submissionDate: result.data[0].assignmentDetails.submissionDate ? moment(result.data.submissionDate).format('ll') : "-",
                    submissionTime: result.data[0].assignmentDetails.submissionTime ? moment(result.data[0].assignmentDetails.submissionTime).format('LT') : "-",
                    notes: result.data[0].assignmentDetails.notes ? result.data[0].assignmentDetails.notes : "-",
                    attachments: result.data[0].assignmentDetails.attachments ? result.data[0].assignmentDetails.attachments : ''
                }
                submitAssignmentObj = {
                    notes: result.data[0].notes,
                }

                remarkAssignmentObj = {
                    assignmentStatus1:result.data[0].assignmentStatus,
                  assignmentRemark:result.data[0].assignmentRemark?result.data[0].assignmentRemark:"No remark",
                  remarkFile:result.data[0].remarkFile
                }

                assignmentStatus = result.data[0].assignmentStatus;
                if (assignmentStatus != "pending" || "submitted") {
                    _$('.remarkDiv').removeClass('d-none')
                }
                
            } else {
                PNotify.error({
                    title: 'Error',
                    text: result.errMsg,
                    delay: 3000
                })
            }
        }


        _$(elem_submitAssignmentFile).filepond('allowMultiple', true);

        if (_id && _submitedFileObj.length) {
            let files = [];
            _submitedFileObj.forEach(element => {
                
                files.push({
                    source: '12345',
                    options: {
                        type: 'local',
                        file: {
                            name: element.originalFileName,
                            size: element.fileSize,
                            customUrl: element.downloadUrl,
                            type: ['application/*', 'image/*', "text/*"]
                        }
                    }
                })
            });
            _$(elem_submitAssignmentFile).filepond("files", files);
        }

        _$(".may-pond .filepond--item-panel").css('background', '#369763')

        // _$(elem_uploadAttachmentInput).on('FilePond:addfile', function (e) {
        //     _$.fn.filepond.setOptions(server);
        // });


    })


    async function api_getAssignmentProgressById() {

        let action = "assignment.getAssignmentProgressById";
        var response = await api_handleApiCalls(action, { id: _id });
        return response;

    }

    async function api_addUpdateAssignment(data) {

        let action = "assignment.submitAssignment";
        var response = await api_handleApiCalls(action, data);
        return response;

    }

    let validateAssignment = () => {
        errorObj = {};
        if (!submitAssignmentObj.notes) {
            var newErrorObj = {};
            if (!submitAssignmentObj.notes) {
                newErrorObj.notes = "Assignment notes is required Field.";
            }

            errorObj = newErrorObj;

        }
        if (Object.keys(errorObj).length > 0) {
            return false;
        }
        return true;


    }

    let addUpdateAssignmentBtn = async () => {
        if (validateAssignment()) {
            submitAssignmentObj.id = _id;
            var assignmentRes = await api_addUpdateAssignment(submitAssignmentObj);
            if (assignmentRes.status) {
                // create success
                PNotify.success({
                    title: 'Success',
                    text: 'Assignment Saved Successfully',
                    delay: 3000
                })
                window.history.back();
            } else {
                PNotify.error({
                    title: 'Error',
                    text: assignmentRes.errMsg,
                    delay: 3000
                })
            }
        }
    }

    let submitBtn = async () => {
        if (validateAssignment()) {
            submitAssignmentObj.id = _id;
            submitAssignmentObj.assignmentStatus = "submitted"
            var assignmentRes = await api_addUpdateAssignment(submitAssignmentObj);
            if (assignmentRes.status) {
                // create success
                PNotify.success({
                    title: 'Success',
                    text: assignmentRes.data,
                    delay: 3000
                })
                window.history.back();
            } else {
                PNotify.error({
                    title: 'Error',
                    text: assignmentRes.errMsg,
                    delay: 3000
                })
            }
        }
    }



</script>


<div class="content-body fadeIn">
    <div class="d-sm-flex align-items-center justify-content-between mg-b-20 mg-lg-b-25 mg-xl-b-30">
        <div>
            <nav use:links aria-label="breadcrumb">
                <ol class="breadcrumb breadcrumb-style1 mg-b-10">
                    <li class="breadcrumb-item"><a href="/dashboard">Dashboard</a></li>
                    <li class="breadcrumb-item"><a href="/dashboard/studentAssignment">Assignment</a></li>
                    <li class="breadcrumb-item"><a href="/dashboard/studentAssignment">View Assignment</a></li>
                    <li class="breadcrumb-item active" aria-current="page">
                        {assignmentObj.topic}
                    </li>
                </ol>
            </nav>
            <h4 class="mg-b-0 tx-spacing--1">
                {assignmentObj.topic}
            </h4>
            <p class=" tx-11 tx-spacing-1 tx-color-03 tx-medium mg-b-0 mg-t-5">
                {#if assignmentStatus == "pending"}
                <span class="badge badge-secondary">{assignmentStatus}</span>
                {:else if assignmentStatus == "submitted"}
                <span class="badge badge-primary">{assignmentStatus}</span>
                {:else if assignmentStatus == "approved"}
                <span class="badge badge-success">{assignmentStatus}</span>
                {:else if assignmentStatus == "rejected"}
                <span class="badge badge-danger">{assignmentStatus}</span>
                {:else if assignmentStatus == "resubmit"}
                <span class="badge badge-warning">{assignmentStatus}</span>
                {/if}
            </p>
        </div>
        <div class="d-block">
            <button on:click={addUpdateAssignmentBtn} class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i
                    data-feather="save" class="wd-10 mg-r-5"></i>
                Save
            </button>

        </div>
    </div>
    <hr class="full-width">
    <!-- <hr class="mg-y-20"> -->
    <div class="mg-b-20 mg-lg-b-25 mg-xl-b-30">

        <div class="row row-sm mg-b-10">
            <div class="col-sm-6">
                <fieldset class="form-fieldset">
                    <legend>Submit Assignment</legend>
                    <div class="form-row">
                        <div class="form-group col-md-12">
                            <label class="d-block">Notes <span class="required-field">*</span></label>
                            <textarea bind:value={submitAssignmentObj.notes} type="text" on:blur={()=>clearError("notes")} class="form-control" class:parsley-error={errorObj.notes} placeholder="Enter your notes"/>
                            {#if errorObj.notes}
                                <div class="parsley-errors-list">{errorObj.notes}</div>
                            {/if}
                        </div>
                    </div>
                    
                <div class="form-row">
                    <div class="form-group col-md-12">
                        <label class="d-block">Upload</label>

                    <input type="file" bind:this={elem_submitAssignmentFile} class="my-pond" data-instant-upload="false" data-allow-image-preview="false" name="filepond" />
                    </div>
                    </div>
                </fieldset>

            </div>
            <div class="col-sm-6">
                

                <div class="card">
                    <!-- <img src="..." class="card-img-top" alt="..."> -->
                    <div class="card-header">
                        <h5>Assignment</h5>
                    </div>
                    <div class="card-body">
                        <h6 class="card-title"><span class="tx-bold">Topic:</span> {assignmentObj.topic}</h6>
                        <p class="card-text"><span class="tx-bold">Submission Date:</span>{assignmentObj.submissionDate}</p>
                        <p class="card-text"><span class="tx-bold">Submission Time:</span>{assignmentObj.submissionTime}</p>
                        <p class="card-text"><span class="tx-bold">Note:</span>{assignmentObj.notes}</p>
    
                        <div class="form-group row col-md-12">
                            <label class="tx-bold">Attachments :</label>
                            {#if assignmentObj.attachments}
                            <ul>
                            {#each assignmentObj.attachments as file}
                            <li><a href="{file.downloadUrl}" target ="_blank">{file.originalFileName}</a></li>
                            {/each}
                            </ul>
                            {:else}
                                -
                            {/if}
                        </div>
                    </div>
                    </div>
           
            </div> 

           
        </div>
    </div>

    <div class="card">
        <div class="card-header">
            <h5>Remark:</h5>
        </div>
        <div class="card-body">
           <p class="card-text"><span class="tx-bold">Remark: </span>{remarkAssignmentObj.assignmentRemark}</p>
            <div class="form-group row col-md-12">
                <label class="tx-bold">Remark File: </label>
                {#if remarkAssignmentObj.remarkFile}
                <ul>
                    {#each remarkAssignmentObj.remarkFile as file}
                  <li>  <a href="{file.downloadUrl}" target="_blank">{file.originalFileName}</a></li>
                {/each}
            </ul>
                {:else}
                    -
                {/if}
            </div>
        </div>
        </div>
    
    <div class="d-sm-flex align-items-center justify-content-end ">
        <div class="d-block">
            <button on:click={addUpdateAssignmentBtn} class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i data-feather="save"
                class="wd-10 mg-r-5"></i>
                        Save
            </button>
            <button on:click={submitBtn} class="btn btn-sm pd-x-15 btn-primary btn-uppercase mg-l-5"><i data-feather="send"
                class="wd-10 mg-r-5"></i>
                    Submit
        </button>
        </div>
    </div>
    </div>


   